import React from 'react';
import Skeleton from 'flow/components/ui-components/Skeleton';

export const ChatDescriptionSkeleton = () => (
    <Skeleton color="text-gray-300">
        <Skeleton.Title className="w-3/4" />
    </Skeleton>
);

export const ChatSummarySkeleton = () => (
    <Skeleton color="text-gray-300">
        <div className="flex w-full flex-col gap-2">
            <Skeleton.Title className="w-11/12" />
            <Skeleton.Title className="w-9/12" />
            <Skeleton.Title className="w-7/12" />
        </div>
    </Skeleton>
);
